/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getCSSPartDemention } from "src/libs/utilities"
import { ILanding, ILandingDelimiter, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import Edge1 from "../useful/edge/Edge1"
import Edge2 from "../useful/edge/Edge2"
import Edge3 from "../useful/edge/Edge3"
import Edge10 from "../useful/edge/Edge10"
import Edge11 from "../useful/edge/Edge11"
import Edge12 from "../useful/edge/Edge12"
import Edge13 from "../useful/edge/Edge13"
import Edge14 from "../useful/edge/Edge14"
import Edge15 from "../useful/edge/Edge15"
import Edge16 from "../useful/edge/Edge16"
import Edge17 from "../useful/edge/Edge17"
import Edge18 from "../useful/edge/Edge18"
import Edge19 from "../useful/edge/Edge19"
import Edge20 from "../useful/edge/Edge20"
import Edge21 from "../useful/edge/Edge21"
import Edge22 from "../useful/edge/Edge22"
import Edge23 from "../useful/edge/Edge23"
import Edge24 from "../useful/edge/Edge24"
import Edge25 from "../useful/edge/Edge25"
import Edge26 from "../useful/edge/Edge26"
import Edge30, { CLIP_PATH_TYPE } from "../useful/edge/Edge30"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
 

/* Protopia Ecosystem component */
export interface IDelimiterContentProps {
   section: ILandingSection
}
const DelimiterContent = (props: IDelimiterContentProps): JSX.Element => {    
    
    const currentLanding: ILanding = useLandingStore((state: ILandingStore) => state.currentLanding)  
    const delimiter: ILandingDelimiter =  props.section?.delimiter && !!Object.keys(props.section.delimiter).length 
        ?
        {
            ...(currentLanding.delimiter || {}),
            ...props.section.delimiter 
        }
        :
        currentLanding.delimiter || {} 
    
    const position = usePosition( delimiter ).position  

    //const [height, setHeight]     = useState<any>( getCssDemention(position.height || delimiter.height || delimiter.style?.height, "1px" ) )
    const height        = getCssDemention( delimiter.height || delimiter.style?.height, "0" )
    const width         = getCssDemention(position.width || delimiter.width || delimiter.style?.width, "100%") 
    const halfWidth     = getCSSPartDemention(position.width || delimiter.width || delimiter.style?.width, "50%", .5) 
    
    useEffect(() => {  
        addCSSClass(
            `section-delimiter-${props.section.id}`,
            `.section-delimiter-${props.section.id} {
                background: ${ delimiter.bg || delimiter.style?.background || delimiter.style?.backgroundColor || delimiter.style?.backgroundImage }!important;
                --width: ${width}!important;
                height:${height}!important;
                margin: 0 auto;
                ${ delimiter.z ? `z-index:${ delimiter.z }!important;` : ``}
                ${ delimiter.style?.zIndex ? `z-index:${ delimiter.style?.zIndex };` : ``}
                left: ${ delimiter.x || delimiter.style?.left 
                    ? 
                    getCssDemention(delimiter.x || delimiter.style?.left, "0")
                    :
                    `calc(50% - ${ halfWidth })` };
            }` 
        )
        return () => {
            removeCSSClass(`section-delimiter-${props.section.id}`)
        }
    }, [ ])
    

    /* css class .landing-edit-cont - edit.select container for get bounds */
    return !!delimiter.isDisabled
        ? 
        <></>
        :
        <div 
            className={`landing-delimiter landing-edit-cont section-delimiter-${props.section.id} `} 
            style={{
                ...delimiter.style,
                width,
                height: height,
                background: `${ delimiter.bg || delimiter.style?.background || delimiter.style?.backgroundColor || delimiter.style?.backgroundImage }`,
                backgroundColor: undefined,
                backgroundImage: undefined,
                left: `${ delimiter.x || delimiter.style?.left 
                    ? 
                    getCssDemention(delimiter.x || delimiter.style?.left, "0")
                    :
                    `calc(50% - ${ halfWidth })` }`,
            }}
        > 
            {
                ( props.section.delimiter?.edges || delimiter.edges || [] ).map((edge, i) => {
                    const edgeData = {
                        ...edge,
                        position: {
                            ...edge.position,
                            height: edge.position?.height || height
                        }
                    }
                    switch( edge.type % 50 ) {
                        case 1:
                            return <Edge2 item={edge} key={i} />
                        case 2:
                            return <Edge3 item={edge} key={i} />
                        case 10:
                            return <Edge10 item={edge} key={i} />
                        case 11:
                            return <Edge11 item={edge} key={i} />
                        case 12:
                            return <Edge12 item={edge} key={i} />
                        case 13:
                            return <Edge13 item={edge} key={i} />
                        case 14:
                            return <Edge14 item={edge} key={i} />
                        case 15:
                            return <Edge15 item={edge} key={i} />
                        case 16:
                            return <Edge16 item={edge} key={i} />
                        case 17:
                            return <Edge17 item={edge} key={i} />
                        case 18:
                            return <Edge18 item={edge} key={i} />
                        case 19:
                            return <Edge19 item={edge} key={i} />
                        case 20:
                            return <Edge20 item={edge} key={i} />
                        case 21:
                            return <Edge21 item={edge} key={i} />
                        case 22:
                            return <Edge22 item={edge} key={i} />
                        case 23:
                            return <Edge23 item={edge} key={i} />
                        case 24:
                            return <Edge24 item={edge} key={i} />
                        case 25:
                            return <Edge25 item={edge} key={i} />
                        case 26:
                            return <Edge26 item={edge} key={i} />
                        case 30:
                            return <Edge30 item={edgeData} clipPathType={CLIP_PATH_TYPE.SHUTE_RIGHT} key={i} />
                        case 31:
                            return <Edge30 item={edgeData} clipPathType={CLIP_PATH_TYPE.SHUTE_LEFT} key={i} />
                        case 0:
                        default:
                            return <Edge1 item={edge} key={i} />
                    }
                })
            }
            { delimiter.element }
        </div>
}
export default DelimiterContent